import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getBackgrounds } from "../../actions/PagesActions";
import useWebsocket from "../useWebsocket";

const OnSettingLoadedComponent = () => {
    const dispatch = useDispatch();
    useWebsocket();
    useEffect(() => {
        dispatch(getBackgrounds());
    }, [])
    return <></>;
}

export default OnSettingLoadedComponent;